import { useContext } from 'react';
import { BookAppointmentContext, BookAppointmentContextValue } from '../providers';

const useBookAppointmentContext = (): BookAppointmentContextValue | undefined => {
  return useContext(BookAppointmentContext);
};

export default useBookAppointmentContext;
